import React from "react";

export default function WhyItMatters() {
  return (
    <div>
      {/* Why It Matters Section */}
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "60px 20px 40px",
        }}
      >
        <h2
          style={{
            fontSize: "2rem",
            fontWeight: "700",
            marginBottom: "20px",
            color: "#1a1a1a",
          }}
        >
          Why It Matters
        </h2>
        <p
          style={{
            fontSize: "1rem",
            lineHeight: "1.7",
            color: "#4a5568",
            maxWidth: "900px",
          }}
        >
          U.S. drug prices are among the highest in the world. But change starts
          with people like you. With just a few clicks, you can speak up for
          transparency and fairness.
        </p>
      </div>

      {/* Stats Section */}
      <div
        style={{
          background: "linear-gradient(135deg, #4fd1c5 0%, #38b2ac 100%)",
          padding: "60px 20px",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "30px",
          }}
        >
          {/* Card 1 */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "12px",
              padding: "40px 30px",
              textAlign: "center",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <div
              style={{
                fontSize: "3rem",
                marginBottom: "15px",
              }}
            >
              📧
            </div>
            <h3
              style={{
                fontSize: "2.5rem",
                fontWeight: "700",
                color: "#1a1a1a",
                marginBottom: "10px",
              }}
            >
              100+
            </h3>
            <p
              style={{
                fontSize: "0.95rem",
                color: "#4a5568",
                margin: "0",
              }}
            >
              Messages sent this month
            </p>
          </div>

          {/* Card 2 */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "12px",
              padding: "40px 30px",
              textAlign: "center",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <div
              style={{
                fontSize: "3rem",
                marginBottom: "15px",
              }}
            >
              🏛️
            </div>
            <h3
              style={{
                fontSize: "2.5rem",
                fontWeight: "700",
                color: "#1a1a1a",
                marginBottom: "10px",
              }}
            >
              38
            </h3>
            <p
              style={{
                fontSize: "0.95rem",
                color: "#4a5568",
                margin: "0",
              }}
            >
              Districts contacted so far
            </p>
          </div>

          {/* Card 3 */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "12px",
              padding: "40px 30px",
              textAlign: "center",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <div
              style={{
                fontSize: "3rem",
                marginBottom: "15px",
              }}
            >
              📈
            </div>
            <h3
              style={{
                fontSize: "2.5rem",
                fontWeight: "700",
                color: "#1a1a1a",
                marginBottom: "10px",
              }}
            >
              89%
            </h3>
            <p
              style={{
                fontSize: "0.95rem",
                color: "#4a5568",
                margin: "0",
              }}
            >
              Response rate from representatives
            </p>
          </div>
        </div>
      </div>

      {/* Responsive Styles */}
      <style>{`
        @media (max-width: 768px) {
          h2 {
            font-size: 1.75rem !important;
          }
          h3 {
            font-size: 2rem !important;
          }
          div[style*="padding: 40px 30px"] {
            padding: 30px 20px !important;
          }
        }
        
        @media (max-width: 480px) {
          h2 {
            font-size: 1.5rem !important;
          }
          h3 {
            font-size: 1.75rem !important;
          }
          div[style*="fontSize: 3rem"] {
            font-size: 2.5rem !important;
          }
        }
      `}</style>
    </div>
  );
}